<ion-item lines="none" class="transparent">
  <ion-list>
    <div [class]="fontSize">
      {{label}}
    </div>
    <img (click)="openModal()" [class]="imageSize" [src]="src" />
  </ion-list>
</ion-item>
